<template>
    <div class="dashboard-editor-container">
      <el-row :gutter="24" class="hearder-warp">
        <el-col :xs="24" :sm="24" :lg="9" class="logo-wrapper">
          <img
          style="width: 52px; height: 40px;margin-right: 10px;"
          src="../../assets/wlLogo.png"
          />
          <h1 class="logo-title">智分瓦力可视化运营管理平台</h1></el-col>
        <el-col :xs="24" :sm="24" :lg="5">
            <el-card class="card-wrap">
                <span>累计减量</span>
                <h1><count-to :start-val="0" :end-val="totalHeadData.totalWeightNums" :duration="3200" class="card-panel-num" /></h1>
                <span>吨</span>
            </el-card>   
        </el-col>
        <el-col :xs="24" :sm="24" :lg="5">
            <el-card class="card-wrap">
              <span>累计订单数</span>
              <h1><count-to :start-val="0" :end-val="totalHeadData.totalOrderNums" :duration="3200" class="card-panel-num" /></h1>
              <span>单</span>
            </el-card>   
        </el-col>
        <el-col :xs="24" :sm="24" :lg="5">
            <el-card class="card-wrap">
                <span>累计用户量</span>
                <h1><count-to :start-val="0" :end-val="totalHeadData.totalUserNums" :duration="3200" class="card-panel-num" /></h1>
                <span>人</span>
            </el-card>   
        </el-col>
      </el-row>
      <el-row :gutter="24" class="chart-card">
        <el-col :xs="24" :sm="24" :lg="8">
          <div class="chart-wrapper wrapper1">
            <el-row :gutter="24"  class="echarts-title">
              <el-col class="title" :lg="14">资源回收总量</el-col>
              <!-- <el-col class="line" :lg="10"></el-col> -->
            </el-row>
            <el-row :gutter="24">
              <el-col :lg="24">
                <pie-chart :pie-data="resouceRecycleData" class-name="total"/>
              </el-col>
              <el-col :lg="10" class="pine-content">
                <el-row :gutter="24" class="pieText"> 
                  <el-col :lg="12">回收种类</el-col>
                  <el-col :lg="12">回收重量</el-col>
                  <el-col :lg="12">可回收物</el-col>
                  <el-col :lg="12"><span class="card-panel-num">{{resouceRecycleData[0].value}}</span> 吨</el-col>
                  <el-col :lg="12">其他</el-col>
                  <el-col :lg="12"><span class="card-panel-num">{{resouceRecycleData[1].value}}</span> 吨</el-col>
                  <!-- <el-col :lg="12">厨余</el-col>
                  <el-col :lg="12"><span class="card-panel-num">{{resouceRecycleData[2].value}}</span> 吨</el-col> -->
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="8">
          <div class="chart-wrapper wrapper2">
            <el-row :gutter="24" class="echarts-title">
              <el-col class="title" :lg="14">节能减排量</el-col>
              <!-- <el-col class="line" :lg="10"></el-col> -->
            </el-row>
            <panel-group :panel-data="reductionEnergyData"/>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="8">
            <div class="chart-wrapper wrapper3">
                <el-row :gutter="24" class="echarts-title">
                <el-col class="title" :lg="14">小区单量TOP5</el-col>
                <!-- <el-col class="line" :lg="10"></el-col> -->
                </el-row>
            <transaction-table :list="communityOrderData"/>
            </div>
           
        </el-col>
      </el-row>
  
      <el-row :gutter="24" class="chart-card">
        <el-col :xs="24" :sm="24" :lg="8">
          <div class="chart-wrapper wrapper4">
            <el-row :gutter="24" class="echarts-title">
                <el-col class="title" :lg="14">今日回收总量和占比</el-col>
                <!-- <el-col class="line" :lg="10"></el-col> -->
            </el-row>
            <el-row :gutter="24">
              <el-col :lg="24">
                <pie-chart :pie-data="todayResouceRecycle" class-name="today"/>
              </el-col>
              <el-col :lg="10" class="pine-content">
                <el-row :gutter="24" class="pieText"> 
                  <el-col :lg="12">回收种类</el-col>
                  <el-col :lg="12">回收重量</el-col>
                  <el-col :lg="12">可回收物</el-col>
                  <el-col :lg="12"><span class="card-panel-num">{{todayResouceRecycle[0].value}}</span> 公斤</el-col>
                  <el-col :lg="12">其他</el-col>
                  <el-col :lg="12"><span class="card-panel-num">{{todayResouceRecycle[1].value}}</span> 公斤</el-col>
                  <!-- <el-col :lg="12">厨余</el-col>
                  <el-col :lg="12"><span class="card-panel-num">{{todayResouceRecycle[2].value}}</span> 公斤</el-col> -->
                </el-row>
              </el-col>
            </el-row>
            
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="8">
            <div class="chart-wrapper wrapper5">
                <el-row :gutter="24" class="echarts-title">
                    <el-col class="title" :lg="14">历史回收总量</el-col>
                    <!-- <el-col class="line" :lg="10"></el-col> -->
                </el-row>
                <bar-chart :xdata="months" :bar-data="historyRecycleData" class-name="historyTotal"/>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :lg="8">
            <div class="chart-wrapper wrapper6">
                <el-row :gutter="24" class="echarts-title">
                    <el-col class="title" :lg="14">近七日回收总量</el-col>
                    <!-- <el-col class="line" :lg="10"></el-col> -->
                </el-row>
                <bar-chart :xdata="labelsDay" :bar-data="todayRecycleData" class-name="todayTotal"/>
           </div>
        </el-col>
      </el-row>
    </div>
  </template>
  
  <script>
  import PanelGroup from './components/PanelGroup'
  import PieChart from './components/PieChart'
  import BarChart from './components/BarChart'
  import TransactionTable from './components/TransactionTable'
  import CountTo from 'vue-count-to'
  import {getTotalHead, getTodayResouceRecycle, getResouceRecycle,getReductionEnergy, getCommunityOrder,getTodayRecycle,getHistoryRecycle} from '@/api/visualization'
  
  const lineChartData = {
    newVisitis: {
      expectedData: [100, 120, 161, 134, 105, 160, 165],
      actualData: [120, 82, 91, 154, 162, 140, 145]
    },
    messages: {
      expectedData: [200, 192, 120, 144, 160, 130, 140],
      actualData: [180, 160, 151, 106, 145, 150, 130]
    },
    purchases: {
      expectedData: [80, 100, 121, 104, 105, 90, 100],
      actualData: [120, 90, 100, 138, 142, 130, 130]
    },
    shoppings: {
      expectedData: [130, 140, 141, 142, 145, 150, 160],
      actualData: [120, 82, 91, 154, 162, 140, 130]
    }
  }
  
  export default {
    name: 'DataStatistics',
    components: {
      PanelGroup,
      PieChart,
      BarChart,
      TransactionTable,
      CountTo
      //BoxCard
    },
    data() {
      return {
        lineChartData: lineChartData.newVisitis,
        totalHeadData: {},
        resouceRecycleData:[],
        todayResouceRecycle:[],
        reductionEnergyData:{},
        communityOrderData: [],
        historyRecycleData: [],
        todayRecycleData: [],
        labelsDay:[],
        months: []
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.getTodayRecycle();
        this.getHistoryRecycle();
        this.getTotalHead();
        this.getTodayResouceRecycle();
        this.getResouceRecycle();
        this.getReductionEnergy();
        this.getCommunityOrder();
    })
      
      
      // 获取当前日期
      const today = new Date();
        for (let i = 0; i < 7; i++) {
          const date = new Date(today);
          date.setDate(today.getDate() - (6 - i)-1);
          this.labelsDay.push(date.toLocaleDateString());
        }
       // 获取当月
        const currentMonth = today.getMonth();
        // 生成月份标签
        for (let i = 0; i < 7; i++) {
          const month = new Date(today);
          month.setMonth(currentMonth - (6 - i)-1);
          this.months.push(month.toLocaleString('default', { month: 'long' }));
        }
    },
    methods: {
      getTotalHead() {
        getTotalHead().then((res)=>{
          this.totalHeadData = res.data;
        })
      },
      getTodayResouceRecycle() {
        getTodayResouceRecycle().then((res)=>{
          this.todayResouceRecycle = res.data.nodeResVOList;
        })
      },
      getResouceRecycle() {
        getResouceRecycle().then((res)=>{
          this.resouceRecycleData = res.data.nodeResVOList;
        })
      },
      getReductionEnergy() {
        getReductionEnergy().then((res)=>{
          this.reductionEnergyData = res.data;
        })
      },
      getCommunityOrder() {
        getCommunityOrder().then((res)=>{
          this.communityOrderData = res.data;
        })
      },
      getHistoryRecycle() {
        getHistoryRecycle().then((res)=>{
          this.historyRecycleData = res.data;
        })
      },
      getTodayRecycle() {
        getTodayRecycle().then((res)=>{
          this.todayRecycleData = res.data;
        })
      },
      format (num) {
         return (num+ '').replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g,'$1,');
      }
    }
  }
  </script>
  
  <style lang="scss">
  .dashboard-editor-container {
    .hearder-warp {
        margin-bottom: 30PX;
    }
    padding: 32px;
    // background: linear-gradient(to right, #080780, #4b6cb7, #182848);
    background-image: url('../../assets/background.jpg');
    background-size: cover; /* 覆盖整个元素 */
    background-repeat: no-repeat;
    background-position: center center;
    position: relative;
    color:#E1E6E6;
    h1 {
      color:#E1E6E6;
    }
    .el-card.card-wrap {
        text-align: center;
        position: relative;
        // border: 2px solid #2466A4FF; /* 使用主色作为边框颜色 */
        // box-shadow: 0 4px 8px rgba(36, 106, 164, 1); /* 添加阴影效果 */
        // transition: box-shadow 0.3s ease-in-out;
        border: none;
        background: url(../../assets/border.png);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
        .el-card__body {
          padding: 0 !important;
        }
        span {
          color:#E1E6E6;
          font-size: 12px;
          display: inline-block;
          height: 100%;
          vertical-align: middle;
          
        }
        h1 {
         display: inline-block;
         color:darkgoldenrod;
         font-size: 38px;
         margin-right: 5px;
         position: relative;
        }
        .card-panel-num {
          font-size: 38px;
           color:darkgoldenrod; 
           padding: 0 !important;
        }
        span:first-child {
          padding-top:26px;
          padding-bottom: 38px;
          padding-right: 5px;
        }
        span:last-child {
            display: inline-block;
            margin-top: 5px;
        }
    }
    .github-corner {
      position: absolute;
      top: 0px;
      border: 0;
      right: 0;
    }
    .chart-wrapper {
      // background-image: linear-gradient(45deg, #1F6EB6, rgba(31, 110, 182, 0.6), rgba(31, 110, 182, 0));
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      // border: 4px solid transparent;
      padding: 60px 18px 10px 18px;
      margin-bottom: 32px;
      // border-radius: 30px;
      // box-shadow: 0 4px 8px 0 rgba(25, 94, 158, 0.5); /* 添加阴影效果 */
      height: 418px;
    }
    .wrapper1, .wrapper3, .wrapper5 {
        background: url(../../assets/card.png);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
      
    }
    .wrapper2, .wrapper4, .wrapper6 {
        background: url(../../assets/card1.png);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
      
    }
    .echarts-title {
        margin-bottom: 10px;
      }
      .title {
        position: relative;
        padding-left: 40px !important;
        font-size: 18px;
        font-weight: 600;
        
      }
      .title::before {
        content: ''; 
        position: absolute;
        left: 30px; 
        top: 0;
        bottom: 0;
        width: 4px;
        background-color:darkgoldenrod;
      }
      .line {
        position: relative;
        padding-left: 10px;
        
      }
      .line::before {
        content: ''; 
        position: absolute;
        left: 0; 
        top: 12px;
        bottom: 0;
        width: 100%;
        height: 4px;
        background-color:#4EA4E1FF;
      }
      .logo-wrapper{
        display: flex;
        justify-content: start;
        align-items: center;
      }
    .logo-title {
      display: inline-block;
    }
  }
  .pieText {
    line-height: 40px;
    font-weight: 600;
    font-size: 14px;
  }
  .pine-content {
    position: absolute;
    right: 3%;
  }
  
  @media (max-width:1024px) {
    .chart-wrapper {
      padding: 8px;
    }
  }
  </style>
  